// FinalizeSurveillanceForm.js
import React, { useState } from "react";
import { BiCheckCircle } from "react-icons/bi";
import SignatureInput from "./ServeeAction/SignatureInput"; // ✅ Import the shared signature component

const FinalizeSurveillanceForm = ({ selectedSubject, location, onSubmit, onCancel, isLoading }) => {
    const [signatureFile, setSignatureFile] = useState(null);

    const subjectName = selectedSubject?.full_name || "Entire Case";

    const handleSubmit = (e) => {
        e.preventDefault();
    

        // Pass final signature file to parent handler
        onSubmit(signatureFile);
    };

    return (
        <div className="p-4 border border-green-300 rounded-md bg-green-50 mb-4">
            <h5 className="font-bold text-green-700 mb-2">
                Finalize Surveillance & Generate Report for: {subjectName}
            </h5>

            <form onSubmit={handleSubmit} className="mt-2 space-y-4">

                {/* ✅ Reusable Signature Pad */}
                <SignatureInput 
                    value={signatureFile} 
                    onChange={setSignatureFile} 
                    label="Field Agent Digital Signature (Required)"
                />

                <div className="flex space-x-2">
                    <button 
                        type="submit" 
                        className="bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-md text-sm font-semibold flex items-center space-x-1 disabled:opacity-50"
                    >
                        <BiCheckCircle className="w-4 h-4" />
                        <span>{isLoading ? 'Generating Report...' : 'Generate Report & Mark Complete'}</span>
                    </button>

                    <button 
                        type="button" 
                        onClick={onCancel} 
                        className="bg-gray-400 hover:bg-gray-500 text-white px-5 py-2 rounded-md text-sm font-semibold"
                    >
                        Cancel
                    </button>
                </div>

            </form>
        </div>
    );
};

export default FinalizeSurveillanceForm;
